import { FC, ReactNode, useState } from "react";
import { QesIcon } from "@app/shared/icons/QESIcon";
import { QesIcons } from "@app/shared/icons/qesIcons";

interface CollapsibleProps {
  title: string;
  children: ReactNode;
  testId?: string;
}

const Collapsible: FC<CollapsibleProps> = ({ title, children, testId }) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <div className="collapsible-section">
      <button
        className="collapsible-section__header"
        onClick={() => setIsOpen(prev => !prev)}
        data-testid={testId}
        aria-expanded={isOpen}
      >
        <h1 className="collapsible-header">{title}</h1>
        <QesIcon iconName={isOpen ? QesIcons.ChevronUp : QesIcons.ChevronDown} description={isOpen ? "collapse" : "expand"} />
      </button>
      {isOpen && <div className="collapsible-section__content">{children}</div>}
    </div>
  );
};

export default Collapsible;
